import React, { useEffect, useState } from 'react';
import API_BASE_URL from '../../config/api';

const SecurityWrapper = ({ children }) => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      const url = `${API_BASE_URL}/admin/manage_settings.php`;
      try {
        const response = await fetch(url);
        const text = await response.text(); // Get raw text first
        
        try {
          const result = JSON.parse(text);
          if (result.status === 'success') {
            setSettings(result.data);
          }
        } catch (jsonError) {
          console.error(`Security settings fetch failed. URL: ${url}`);
          console.error(`Status: ${response.status} ${response.statusText}`);
          console.error(`Raw response (first 200 chars): ${text.substring(0, 200)}`);
          console.error(jsonError);
        }
      } catch (error) {
        console.error(`Network or fetch error. URL: ${url}`, error);
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    if (!settings || settings.master_security_mode === '0') return;

    // 1. Disable Right Click
    const handleContextMenu = (e) => {
      if (settings.disable_right_click === '1') {
        e.preventDefault();
      }
    };

    // 2. Disable Dev Tools Keys
    const handleKeyDown = (e) => {
      if (settings.disable_dev_tools === '1') {
        // F12
        if (e.keyCode === 123) e.preventDefault();
        // Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+Shift+C
        if (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67)) e.preventDefault();
        // Ctrl+U (View Source)
        if (e.ctrlKey && e.keyCode === 85) e.preventDefault();
      }
    };

    // 3. Disable Console Panel
    let originalConsole;
    if (settings.disable_dev_tools === '1') {
      originalConsole = { ...window.console };
      const noop = () => {};
      window.console.log = noop;
      window.console.warn = noop;
      window.console.error = noop;
      window.console.info = noop;
      window.console.debug = noop;
      window.console.dir = noop;
    }

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      if (originalConsole) {
        window.console = originalConsole;
      }
    };
  }, [settings]);

  return <>{children}</>;
};

export default SecurityWrapper;
